import { useMemo } from 'react'
import { v4 as uuidv4 } from 'uuid'

import { SalesByCustomerReportTableAccessor } from '../../enums/salesByCustomerReportTableAccessor'
import { SalesByValueReportTableRow } from '../../types/salesByValueReportTableRow'
import { useSalesByCustomerReport } from './useSalesByCustomerReport'

export const useSalesByCustomerReportTableData = (): SalesByValueReportTableRow[] => {
  const { salesByCustomerReport } = useSalesByCustomerReport()

  return useMemo(
    () =>
      salesByCustomerReport.map(({ customerName, summary }) => {
        return {
          [SalesByCustomerReportTableAccessor.CustomerName]: customerName,
          [SalesByCustomerReportTableAccessor.GrossTotal]: summary.all.grossTotal,
          [SalesByCustomerReportTableAccessor.NetTotal]: summary.all.netTotal,
          id: uuidv4(),
        }
      }),
    [salesByCustomerReport],
  )
}
